import { createReducer, on } from '@ngrx/store';
import {
  loadDrawings,
  loadDrawingsSuccess,
  loadDrawingsFailure,
  addDrawing,
  addDrawingSuccess,
  addDrawingFailure,
  clearDrawings,
} from './drawings.actions';
import { DrawingsState } from '../../interfaces/state/reducers/drawings-state.interface';

export const initialState: DrawingsState = {
  drawings: [],
  currentFloorId: null,
  loading: false,
  error: null,
};

export const drawingsReducer = createReducer(
  initialState,
  on(loadDrawings, (state, { floorId }) => ({ ...state, currentFloorId: floorId, loading: true, error: null })),
  on(loadDrawingsSuccess, (state, { drawings }) => ({
    ...state,
    drawings,
    loading: false,
  })),
  on(loadDrawingsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  // Uploads run in the background, so they must not raise the global loading overlay.
  on(addDrawing, (state) => ({ ...state, error: null })),
  // The upload may finish after the user has moved to another floor; only merge into the floor on screen.
  on(addDrawingSuccess, (state, { drawing }) =>
    drawing.floorId !== state.currentFloorId
      ? state
      : {
          ...state,
          drawings: state.drawings.some((d) => d.id === drawing.id)
            ? state.drawings.map((d) => (d.id === drawing.id ? drawing : d))
            : [...state.drawings, drawing],
        }
  ),
  on(addDrawingFailure, (state) => ({ ...state, error: null })),
  on(clearDrawings, () => initialState)
);
